export const Zones = [
    {
        id: 1,
        name: "Europe - Schengen Exclusif"
    },
    {
        id: 2,
        name: "Europe et Schengen"
    },
    {
        id: 3,
        name: "Monde Entier (excepté le pays de résidence de l'assuré(e))"
    },
    {
        id: 4,
        name: "Monde Entier"
    },
    {
        id: 5,
        name: "Monde Entier (excepté le Nigéria et le pays de résidence de l'assuré(e))"
    },
]

export const Ages = [
    {
        id: 1,
        label: "until_18",
        description: "Moins de 18 ans"
    },
    {
        id: 2,
        label: "19_to_65",
        description: "De 19 ans à 65 ans"
    },
    {
        id: 3,
        label: "66_to_75",
        description: "De 66 ans à 75 ans"
    },
    {
        id: 4,
        label: "76_to_80",
        description: "De 76 ans à 80 ans"
    },
    {
        id: 5,
        label: "over_81",
        description: "Au-delà de 81 ans"
    },
]

export const Durations = [
    {
        id: 1,
        label: "1-7",
        description: "Jusqu'à 7 jours",
        zone_id: '1-2-3'
    },
    {
        id: 2,
        label: "1-10",
        description: "Jusqu'à 10 jours",
        zone_id: '1-2-3'
    },
    {
        id: 3,
        label: "1-15",
        description: "Jusqu'à 15 jours",
        zone_id: '1-2-3'
    },
    {
        id: 4,
        label: "1-21",
        description: "Jusqu'à 21 jours",
        zone_id: '1-2-3'
    },
    {
        id: 5,
        label: "1-31",
        description: "Jusqu'à 31 jours",
        zone_id: '1-2-3'
    },
    {
        id: 6,
        label: "1-45",
        description: "Jusqu'à 45 jours",
        zone_id: '1-2-3'
    },
    {
        id: 7,
        label: "1-60",
        description: "Jusqu'à 60 jours",
        zone_id: '1-2-3'
    },
    {
        id: 8,
        label: "1-92",
        description: "Jusqu'à 92 jours",
        zone_id: '1-2-3'
    },
    {
        id: 9,
        label: "1-180",
        description: "Jusqu'à 180 jours",
        zone_id: '1-2-3'
    },
    {
        id: 10,
        label: "1-365",
        description: "Jusqu'à 365 jours",
        zone_id: '1-2-3'
    },
    {
        id: 11,
        label: "1-730",
        description: "Jusqu'à 730 jours",
        zone_id: '1-2-3'
    },

    // Students Durations
    {
        id: 12,
        label: "180",
        description: "6 Mois - maximum 180 Jours consécutifs",
        zone_id: 4
    },
    {
        id: 13,
        label: "276",
        description: "9 Mois - maximum 180 Jours consécutifs",
        zone_id: 4
    },
    {
        id: 14,
        label: "365",
        description: "1 an - maximum 365 Jours consécutifs",
        zone_id: 4
    },

    // Pilgrimages Durations
    {
        id: 15,
        label: "15",
        description: "Jusqu'à 15 Jours",
        zone_id: 5
    },
    {
        id: 16,
        label: "30",
        description: "Jusqu'à 30 Jours",
        zone_id: 5
    },
    {
        id: 17,
        label: "45",
        description: "Jusqu'à 45 Jours",
        zone_id: 5
    },
]

export const Prices = [
    /* Europe - Shenguen Exclusif */
    // Moins de 18 ans
    {
        id: 1,
        prime_nette: 4989,
        cout_piece: 1500,
        taxe: 389,
        prime_total: 6878,
        zone_id: 1,
        age_id: 1,
        duration_id: 1,
    },
    {
        id: 2,
        prime_nette: 5324,
        cout_piece: 1500,
        taxe: 409,
        prime_total: 7233,
        zone_id: 1,
        age_id: 1,
        duration_id: 2,
    },
    {
        id: 3,
        prime_nette: 5652,
        cout_piece: 1500,
        taxe: 429,
        prime_total: 7581,
        zone_id: 1,
        age_id: 1,
        duration_id: 3,
    },
    {
        id: 4,
        prime_nette: 6481,
        cout_piece: 1500,
        taxe: 479,
        prime_total: 8460,
        zone_id: 1,
        age_id: 1,
        duration_id: 4,
    },
    {
        id: 5,
        prime_nette: 6813,
        cout_piece: 1500,
        taxe: 499,
        prime_total: 8811,
        zone_id: 1,
        age_id: 1,
        duration_id: 5,
    },
    {
        id: 6,
        prime_nette: 7806,
        cout_piece: 1500,
        taxe: 558,
        prime_total: 9865,
        zone_id: 1,
        age_id: 1,
        duration_id: 6,
    },
    {
        id: 7,
        prime_nette: 8636,
        cout_piece: 1500,
        taxe: 608,
        prime_total: 10744,
        zone_id: 1,
        age_id: 1,
        duration_id: 7,
    },
    {
        id: 8,
        prime_nette: 10955,
        cout_piece: 1500,
        taxe: 747,
        prime_total: 13202,
        zone_id: 1,
        age_id: 1,
        duration_id: 8,
    },
    {
        id: 9,
        prime_nette: 12283,
        cout_piece: 1500,
        taxe: 827,
        prime_total: 14610,
        zone_id: 1,
        age_id: 1,
        duration_id: 9,
    },
    {
        id: 10,
        prime_nette: 16422,
        cout_piece: 1500,
        taxe: 1075,
        prime_total: 18998,
        zone_id: 1,
        age_id: 1,
        duration_id: 10,
    },
    {
        id: 11,
        prime_nette: 28682,
        cout_piece: 1500,
        taxe: 1811,
        prime_total: 31993,
        zone_id: 1,
        age_id: 1,
        duration_id: 11,
    },

    // De 19 à 65 ans
    {
        id: 12,
        prime_nette: 6478,
        cout_piece: 1500,
        taxe: 479,
        prime_total: 8457,
        zone_id: 1,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 13,
        prime_nette: 7147,
        cout_piece: 1500,
        taxe: 519,
        prime_total: 9166,
        zone_id: 1,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 14,
        prime_nette: 7803,
        cout_piece: 1500,
        taxe: 558,
        prime_total: 9861,
        zone_id: 1,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 15,
        prime_nette: 9463,
        cout_piece: 1500,
        taxe: 658,
        prime_total: 11620,
        zone_id: 1,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 16,
        prime_nette: 10125,
        cout_piece: 1500,
        taxe: 698,
        prime_total: 12323,
        zone_id: 1,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 17,
        prime_nette: 12113,
        cout_piece: 1500,
        taxe: 817,
        prime_total: 14429,
        zone_id: 1,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 18,
        prime_nette: 13772,
        cout_piece: 1500,
        taxe: 916,
        prime_total: 16189,
        zone_id: 1,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 19,
        prime_nette: 18410,
        cout_piece: 1500,
        taxe: 1195,
        prime_total: 21104,
        zone_id: 1,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 20,
        prime_nette: 21067,
        cout_piece: 1500,
        taxe: 1354,
        prime_total: 23921,
        zone_id: 1,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 21,
        prime_nette: 29345,
        cout_piece: 1500,
        taxe: 1851,
        prime_total: 32695,
        zone_id: 1,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 22,
        prime_nette: 53864,
        cout_piece: 1500,
        taxe: 3322,
        prime_total: 58686,
        zone_id: 1,
        age_id: 2,
        duration_id: 11,
    },

    // De 66 à 75 ans
    {
        id: 23,
        prime_nette: 7967,
        cout_piece: 1500,
        taxe: 568,
        prime_total: 10035,
        zone_id: 1,
        age_id: 3,
        duration_id: 1,
    },
    {
        id: 24,
        prime_nette: 8971,
        cout_piece: 1500,
        taxe: 628,
        prime_total: 11099,
        zone_id: 1,
        age_id: 3,
        duration_id: 2,
    },
    {
        id: 25,
        prime_nette: 9955,
        cout_piece: 1500,
        taxe: 687,
        prime_total: 12142,
        zone_id: 1,
        age_id: 3,
        duration_id: 3,
    },
    {
        id: 26,
        prime_nette: 12444,
        cout_piece: 1500,
        taxe: 837,
        prime_total: 14781,
        zone_id: 1,
        age_id: 3,
        duration_id: 4,
    },
    {
        id: 27,
        prime_nette: 13438,
        cout_piece: 1500,
        taxe: 896,
        prime_total: 15834,
        zone_id: 1,
        age_id: 3,
        duration_id: 5,
    },
    {
        id: 28,
        prime_nette: 16419,
        cout_piece: 1500,
        taxe: 1075,
        prime_total: 18994,
        zone_id: 1,
        age_id: 3,
        duration_id: 6,
    },
    {
        id: 29,
        prime_nette: 18908,
        cout_piece: 1500,
        taxe: 1225,
        prime_total: 21633,
        zone_id: 1,
        age_id: 3,
        duration_id: 7,
    },
    {
        id: 30,
        prime_nette: 25865,
        cout_piece: 1500,
        taxe: 1642,
        prime_total: 29007,
        zone_id: 1,
        age_id: 3,
        duration_id: 8,
    },
    {
        id: 31,
        prime_nette: 29850,
        cout_piece: 1500,
        taxe: 1881,
        prime_total: 33231,
        zone_id: 1,
        age_id: 3,
        duration_id: 9,
    },
    {
        id: 32,
        prime_nette: 42267,
        cout_piece: 1500,
        taxe: 2626,
        prime_total: 46393,
        zone_id: 1,
        age_id: 3,
        duration_id: 10,
    },
    {
        id: 33,
        prime_nette: 79047,
        cout_piece: 1500,
        taxe: 4833,
        prime_total: 85379,
        zone_id: 1,
        age_id: 3,
        duration_id: 11,
    },

    // De 76 à 80 ans
    {
        id: 34,
        prime_nette: 9456,
        cout_piece: 1500,
        taxe: 657,
        prime_total: 11613,
        zone_id: 1,
        age_id: 4,
        duration_id: 1,
    },
    {
        id: 35,
        prime_nette: 10794,
        cout_piece: 1500,
        taxe: 738,
        prime_total: 13032,
        zone_id: 1,
        age_id: 4,
        duration_id: 2,
    },
    {
        id: 36,
        prime_nette: 12106,
        cout_piece: 1500,
        taxe: 816,
        prime_total: 14423,
        zone_id: 1,
        age_id: 4,
        duration_id: 3,
    },
    {
        id: 37,
        prime_nette: 15425,
        cout_piece: 1500,
        taxe: 1016,
        prime_total: 17941,
        zone_id: 1,
        age_id: 4,
        duration_id: 4,
    },
    {
        id: 38,
        prime_nette: 16750,
        cout_piece: 1500,
        taxe: 1095,
        prime_total: 19345,
        zone_id: 1,
        age_id: 4,
        duration_id: 5,
    },
    {
        id: 39,
        prime_nette: 20725,
        cout_piece: 1500,
        taxe: 1334,
        prime_total: 23559,
        zone_id: 1,
        age_id: 4,
        duration_id: 6,
    },
    {
        id: 40,
        prime_nette: 24045,
        cout_piece: 1500,
        taxe: 1533,
        prime_total: 27077,
        zone_id: 1,
        age_id: 4,
        duration_id: 7,
    },
    {
        id: 41,
        prime_nette: 33320,
        cout_piece: 1500,
        taxe: 2089,
        prime_total: 36909,
        zone_id: 1,
        age_id: 4,
        duration_id: 8,
    },
    {
        id: 42,
        prime_nette: 38633,
        cout_piece: 1500,
        taxe: 2408,
        prime_total: 42541,
        zone_id: 1,
        age_id: 4,
        duration_id: 9,
    },
    {
        id: 43,
        prime_nette: 55189,
        cout_piece: 1500,
        taxe: 3401,
        prime_total: 60091,
        zone_id: 1,
        age_id: 4,
        duration_id: 10,
    },
    {
        id: 44,
        prime_nette: 104229,
        cout_piece: 1500,
        taxe: 6344,
        prime_total: 112072,
        zone_id: 1,
        age_id: 4,
        duration_id: 11,
    },

    // Au-delà de 81 ans
    {
        id: 45,
        prime_nette: 12434,
        cout_piece: 1500,
        taxe: 836,
        prime_total: 14770,
        zone_id: 1,
        age_id: 5,
        duration_id: 1,
    },
    {
        id: 46,
        prime_nette: 14441,
        cout_piece: 1500,
        taxe: 956,
        prime_total: 16898,
        zone_id: 1,
        age_id: 5,
        duration_id: 2,
    },
    {
        id: 47,
        prime_nette: 16409,
        cout_piece: 1500,
        taxe: 1075,
        prime_total: 18984,
        zone_id: 1,
        age_id: 5,
        duration_id: 3,
    },
    {
        id: 48,
        prime_nette: 21388,
        cout_piece: 1500,
        taxe: 1373,
        prime_total: 24261,
        zone_id: 1,
        age_id: 5,
        duration_id: 4,
    },
    {
        id: 49,
        prime_nette: 23375,
        cout_piece: 1500,
        taxe: 1493,
        prime_total: 26368,
        zone_id: 1,
        age_id: 5,
        duration_id: 5,
    },
    {
        id: 50,
        prime_nette: 29338,
        cout_piece: 1500,
        taxe: 1850,
        prime_total: 32688,
        zone_id: 1,
        age_id: 5,
        duration_id: 6,
    },
    {
        id: 51,
        prime_nette: 34317,
        cout_piece: 1500,
        taxe: 2149,
        prime_total: 37966,
        zone_id: 1,
        age_id: 5,
        duration_id: 7,
    },
    {
        id: 52,
        prime_nette: 48230,
        cout_piece: 1500,
        taxe: 2984,
        prime_total: 52713,
        zone_id: 1,
        age_id: 5,
        duration_id: 8,
    },
    {
        id: 53,
        prime_nette: 56200,
        cout_piece: 1500,
        taxe: 3462,
        prime_total: 61162,
        zone_id: 1,
        age_id: 5,
        duration_id: 9,
    },
    {
        id: 54,
        prime_nette: 81034,
        cout_piece: 1500,
        taxe: 4952,
        prime_total: 87486,
        zone_id: 1,
        age_id: 5,
        duration_id: 10,
    },
    {
        id: 55,
        prime_nette: 154593,
        cout_piece: 1500,
        taxe: 9366,
        prime_total: 165459,
        zone_id: 1,
        age_id: 5,
        duration_id: 11,
    },
    
    /* Europe et Schengen */
    // Moins de 18 ans
    {
        id: 56,
        prime_nette: 5671,
        cout_piece: 1500,
        taxe: 430,
        prime_total: 7601,
        zone_id: 2,
        age_id: 1,
        duration_id: 1,
    },
    {
        id: 57,
        prime_nette: 6153,
        cout_piece: 1500,
        taxe: 459,
        prime_total: 8113,
        zone_id: 2,
        age_id: 1,
        duration_id: 2,
    },
    {
        id: 58,
        prime_nette: 6635,
        cout_piece: 1500,
        taxe: 488,
        prime_total: 8624,
        zone_id: 2,
        age_id: 1,
        duration_id: 3,
    },
    {
        id: 59,
        prime_nette: 7839,
        cout_piece: 1500,
        taxe: 560,
        prime_total: 9900,
        zone_id: 2,
        age_id: 1,
        duration_id: 4,
    },
    {
        id: 60,
        prime_nette: 8321,
        cout_piece: 1500,
        taxe: 589,
        prime_total: 10411,
        zone_id: 2,
        age_id: 1,
        duration_id: 5,
    },
    {
        id: 61,
        prime_nette: 9768,
        cout_piece: 1500,
        taxe: 676,
        prime_total: 11944,
        zone_id: 2,
        age_id: 1,
        duration_id: 6,
    },
    {
        id: 62,
        prime_nette: 10975,
        cout_piece: 1500,
        taxe: 748,
        prime_total: 13223,
        zone_id: 2,
        age_id: 1,
        duration_id: 7,
    },
    {
        id: 63,
        prime_nette: 14350,
        cout_piece: 1500,
        taxe: 951,
        prime_total: 16801,
        zone_id: 2,
        age_id: 1,
        duration_id: 8,
    },
    {
        id: 64,
        prime_nette: 16278,
        cout_piece: 1500,
        taxe: 1067,
        prime_total: 18845,
        zone_id: 2,
        age_id: 1,
        duration_id: 9,
    },
    {
        id: 65,
        prime_nette: 22303,
        cout_piece: 1500,
        taxe: 1428,
        prime_total: 25231,
        zone_id: 2,
        age_id: 1,
        duration_id: 10,
    },
    {
        id: 66,
        prime_nette: 40142,
        cout_piece: 1500,
        taxe: 2499,
        prime_total: 44140,
        zone_id: 2,
        age_id: 1,
        duration_id: 11,
    },

    // De 19 ans à 65 ans
    {
        id: 67,
        prime_nette: 7842,
        cout_piece: 1500,
        taxe: 561,
        prime_total: 9903,
        zone_id: 2,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 68,
        prime_nette: 8807,
        cout_piece: 1500,
        taxe: 618,
        prime_total: 10925,
        zone_id: 2,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 69,
        prime_nette: 9771,
        cout_piece: 1500,
        taxe: 676,
        prime_total: 11947,
        zone_id: 2,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 70,
        prime_nette: 12178,
        cout_piece: 1500,
        taxe: 821,
        prime_total: 14499,
        zone_id: 2,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 71,
        prime_nette: 13143,
        cout_piece: 1500,
        taxe: 879,
        prime_total: 15521,
        zone_id: 2,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 72,
        prime_nette: 16035,
        cout_piece: 1500,
        taxe: 1052,
        prime_total: 18587,
        zone_id: 2,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 73,
        prime_nette: 18449,
        cout_piece: 1500,
        taxe: 1197,
        prime_total: 21146,
        zone_id: 2,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 74,
        prime_nette: 25199,
        cout_piece: 1500,
        taxe: 1602,
        prime_total: 28301,
        zone_id: 2,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 75,
        prime_nette: 29056,
        cout_piece: 1500,
        taxe: 1833,
        prime_total: 32389,
        zone_id: 2,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 76,
        prime_nette: 41106,
        cout_piece: 1500,
        taxe: 2556,
        prime_total: 45162,
        zone_id: 2,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 77,
        prime_nette: 76784,
        cout_piece: 1500,
        taxe: 4697,
        prime_total: 82981,
        zone_id: 2,
        age_id: 2,
        duration_id: 11,
    },

    // De 66 ans à 75 ans
    {
        id: 78,
        prime_nette: 10014,
        cout_piece: 1500,
        taxe: 691,
        prime_total: 12204,
        zone_id: 2,
        age_id: 3,
        duration_id: 1,
    },
    {
        id: 79,
        prime_nette: 11460,
        cout_piece: 1500,
        taxe: 778,
        prime_total: 13738,
        zone_id: 2,
        age_id: 3,
        duration_id: 2,
    },
    {
        id: 80,
        prime_nette: 12906,
        cout_piece: 1500,
        taxe: 864,
        prime_total: 15271,
        zone_id: 2,
        age_id: 3,
        duration_id: 3,
    },
    {
        id: 81,
        prime_nette: 16517,
        cout_piece: 1500,
        taxe: 1081,
        prime_total: 19099,
        zone_id: 2,
        age_id: 3,
        duration_id: 4,
    },
    {
        id: 82,
        prime_nette: 17964,
        cout_piece: 1500,
        taxe: 1168,
        prime_total: 20632,
        zone_id: 2,
        age_id: 3,
        duration_id: 5,
    },
    {
        id: 83,
        prime_nette: 22303,
        cout_piece: 1500,
        taxe: 1428,
        prime_total: 25231,
        zone_id: 2,
        age_id: 3,
        duration_id: 6,
    },
    {
        id: 84,
        prime_nette: 25924,
        cout_piece: 1500,
        taxe: 1645,
        prime_total: 29069,
        zone_id: 2,
        age_id: 3,
        duration_id: 7,
    },
    {
        id: 85,
        prime_nette: 36049,
        cout_piece: 1500,
        taxe: 2253,
        prime_total: 39802,
        zone_id: 2,
        age_id: 3,
        duration_id: 8,
    },
    {
        id: 86,
        prime_nette: 41834,
        cout_piece: 1500,
        taxe: 2600,
        prime_total: 45934,
        zone_id: 2,
        age_id: 3,
        duration_id: 9,
    },
    {
        id: 87,
        prime_nette: 59909,
        cout_piece: 1500,
        taxe: 3685,
        prime_total: 65094,
        zone_id: 2,
        age_id: 3,
        duration_id: 10,
    },
    {
        id: 88,
        prime_nette: 113425,
        cout_piece: 1500,
        taxe: 6896,
        prime_total: 121821,
        zone_id: 2,
        age_id: 3,
        duration_id: 11,
    },

    // De 76 ans à 80 ans
    {
        id: 89,
        prime_nette: 12185,
        cout_piece: 1500,
        taxe: 821,
        prime_total: 14506,
        zone_id: 2,
        age_id: 4,
        duration_id: 1,
    },
    {
        id: 90,
        prime_nette: 14113,
        cout_piece: 1500,
        taxe: 937,
        prime_total: 16550,
        zone_id: 2,
        age_id: 4,
        duration_id: 2,
    },
    {
        id: 91,
        prime_nette: 16042,
        cout_piece: 1500,
        taxe: 1053,
        prime_total: 18594,
        zone_id: 2,
        age_id: 4,
        duration_id: 3,
    },
    {
        id: 92,
        prime_nette: 20857,
        cout_piece: 1500,
        taxe: 1341,
        prime_total: 23698,
        zone_id: 2,
        age_id: 4,
        duration_id: 4,
    },
    {
        id: 93,
        prime_nette: 22785,
        cout_piece: 1500,
        taxe: 1457,
        prime_total: 25742,
        zone_id: 2,
        age_id: 4,
        duration_id: 5,
    },
    {
        id: 94,
        prime_nette: 28571,
        cout_piece: 1500,
        taxe: 1804,
        prime_total: 31875,
        zone_id: 2,
        age_id: 4,
        duration_id: 6,
    },
    {
        id: 95,
        prime_nette: 33399,
        cout_piece: 1500,
        taxe: 2094,
        prime_total: 36992,
        zone_id: 2,
        age_id: 4,
        duration_id: 7,
    },
    {
        id: 96,
        prime_nette: 46898,
        cout_piece: 1500,
        taxe: 2904,
        prime_total: 51302,
        zone_id: 2,
        age_id: 4,
        duration_id: 8,
    },
    {
        id: 97,
        prime_nette: 54612,
        cout_piece: 1500,
        taxe: 3367,
        prime_total: 59479,
        zone_id: 2,
        age_id: 4,
        duration_id: 9,
    },
    {
        id: 98,
        prime_nette: 78712,
        cout_piece: 1500,
        taxe: 4813,
        prime_total: 85025,
        zone_id: 2,
        age_id: 4,
        duration_id: 10,
    },
    {
        id: 99,
        prime_nette: 150067,
        cout_piece: 1500,
        taxe: 9094,
        prime_total: 160661,
        zone_id: 2,
        age_id: 4,
        duration_id: 11,
    },

    // Au-delà de 81 ans
    {
        id: 100,
        prime_nette: 16527,
        cout_piece: 1500,
        taxe: 1082,
        prime_total: 19109,
        zone_id: 2,
        age_id: 5,
        duration_id: 1,
    },
    {
        id: 101,
        prime_nette: 19420,
        cout_piece: 1500,
        taxe: 1255,
        prime_total: 22175,
        zone_id: 2,
        age_id: 5,
        duration_id: 2,
    },
    {
        id: 102,
        prime_nette: 22313,
        cout_piece: 1500,
        taxe: 1429,
        prime_total: 25242,
        zone_id: 2,
        age_id: 5,
        duration_id: 3,
    },
    {
        id: 103,
        prime_nette: 29535,
        cout_piece: 1500,
        taxe: 1862,
        prime_total: 32897,
        zone_id: 2,
        age_id: 5,
        duration_id: 4,
    },
    {
        id: 104,
        prime_nette: 32428,
        cout_piece: 1500,
        taxe: 2036,
        prime_total: 35963,
        zone_id: 2,
        age_id: 5,
        duration_id: 5,
    },
    {
        id: 105,
        prime_nette: 41106,
        cout_piece: 1500,
        taxe: 2556,
        prime_total: 45162,
        zone_id: 2,
        age_id: 5,
        duration_id: 6,
    },
    {
        id: 106,
        prime_nette: 48348,
        cout_piece: 1500,
        taxe: 2991,
        prime_total: 52839,
        zone_id: 2,
        age_id: 5,
        duration_id: 7,
    },
    {
        id: 107,
        prime_nette: 68597,
        cout_piece: 1500,
        taxe: 4206,
        prime_total: 74303,
        zone_id: 2,
        age_id: 5,
        duration_id: 8,
    },
    {
        id: 108,
        prime_nette: 80168,
        cout_piece: 1500,
        taxe: 4900,
        prime_total: 86568,
        zone_id: 2,
        age_id: 5,
        duration_id: 9,
    },
    {
        id: 109,
        prime_nette: 116318,
        cout_piece: 1500,
        taxe: 7069,
        prime_total: 124887,
        zone_id: 2,
        age_id: 5,
        duration_id: 10,
    },
    {
        id: 110,
        prime_nette: 223351,
        cout_piece: 1500,
        taxe: 13491,
        prime_total: 238342,
        zone_id: 2,
        age_id: 5,
        duration_id: 11,
    },

    /* Monde Entier (excepté pays de résidence de l'assuré(e)) */
    // Moins de 18 ans
    // Produit A - Economie
    {
        id: 111,
        prime_nette: 5429,
        cout_piece: 1500,
        taxe: 416,
        prime_total: 7344,
        product_id: 1,
        age_id: 1,
        duration_id: 1,
    },
    {
        id: 112,
        prime_nette: 5911,
        cout_piece: 1500,
        taxe: 445,
        prime_total: 7855,
        product_id: 1,
        age_id: 1,
        duration_id: 2,
    },
    {
        id: 113,
        prime_nette: 6393,
        cout_piece: 1500,
        taxe: 474,
        prime_total: 8366,
        product_id: 1,
        age_id: 1,
        duration_id: 3,
    },
    {
        id: 114,
        prime_nette: 7600,
        cout_piece: 1500,
        taxe: 546,
        prime_total: 9646,
        product_id: 1,
        age_id: 1,
        duration_id: 4,
    },
    {
        id: 115,
        prime_nette: 8082,
        cout_piece: 1500,
        taxe: 575,
        prime_total: 10157,
        product_id: 1,
        age_id: 1,
        duration_id: 5,
    },
    {
        id: 116,
        prime_nette: 9286,
        cout_piece: 1500,
        taxe: 647,
        prime_total: 11433,
        product_id: 1,
        age_id: 1,
        duration_id: 6,
    },
    {
        id: 117,
        prime_nette: 10975,
        cout_piece: 1500,
        taxe: 748,
        prime_total: 13223,
        product_id: 1,
        age_id: 1,
        duration_id: 7,
    },
    {
        id: 118,
        prime_nette: 13867,
        cout_piece: 1500,
        taxe: 922,
        prime_total: 16289,
        product_id: 1,
        age_id: 1,
        duration_id: 8,
    },
    {
        id: 119,
        prime_nette: 16035,
        cout_piece: 1500,
        taxe: 1052,
        prime_total: 18587,
        product_id: 1,
        age_id: 1,
        duration_id: 9,
    },
    {
        id: 120,
        prime_nette: 19171,
        cout_piece: 1500,
        taxe: 1240,
        prime_total: 21911,
        product_id: 1,
        age_id: 1,
        duration_id: 10,
    },
    {
        id: 121,
        prime_nette: 33874,
        cout_piece: 1500,
        taxe: 2122,
        prime_total: 37497,
        product_id: 1,
        age_id: 1,
        duration_id: 11,
    },

    // Produit B - Perle
    {
        id: 122,
        prime_nette: 7357,
        cout_piece: 1500,
        taxe: 531,
        prime_total: 9388,
        product_id: 2,
        age_id: 1,
        duration_id: 1,
    },
    {
        id: 123,
        prime_nette: 7839,
        cout_piece: 1500,
        taxe: 560,
        prime_total: 9900,
        product_id: 2,
        age_id: 1,
        duration_id: 2,
    },
    {
        id: 124,
        prime_nette: 9528,
        cout_piece: 1500,
        taxe: 662,
        prime_total: 11690,
        product_id: 2,
        age_id: 1,
        duration_id: 3,
    },
    {
        id: 125,
        prime_nette: 10250,
        cout_piece: 1500,
        taxe: 705,
        prime_total: 12455,
        product_id: 2,
        age_id: 1,
        duration_id: 4,
    },
    {
        id: 126,
        prime_nette: 12178,
        cout_piece: 1500,
        taxe: 821,
        prime_total: 14499,
        product_id: 2,
        age_id: 1,
        duration_id: 5,
    },
    {
        id: 127,
        prime_nette: 13143,
        cout_piece: 1500,
        taxe: 879,
        prime_total: 15521,
        product_id: 2,
        age_id: 1,
        duration_id: 6,
    },
    {
        id: 128,
        prime_nette: 14350,
        cout_piece: 1500,
        taxe: 951,
        prime_total: 16801,
        product_id: 2,
        age_id: 1,
        duration_id: 7,
    },
    {
        id: 129,
        prime_nette: 19653,
        cout_piece: 1500,
        taxe: 1269,
        prime_total: 22422,
        product_id: 2,
        age_id: 1,
        duration_id: 8,
    },
    {
        id: 130,
        prime_nette: 21821,
        cout_piece: 1500,
        taxe: 1399,
        prime_total: 24720,
        product_id: 2,
        age_id: 1,
        duration_id: 9,
    },
    {
        id: 131,
        prime_nette: 25196,
        cout_piece: 1500,
        taxe: 1602,
        prime_total: 28298,
        product_id: 2,
        age_id: 1,
        duration_id: 10,
    },
    {
        id: 132,
        prime_nette: 44241,
        cout_piece: 1500,
        taxe: 2744,
        prime_total: 48486,
        product_id: 2,
        age_id: 1,
        duration_id: 11,
    },

    // Produit C - Voyageur
    {
        id: 133,
        prime_nette: 11926,
        cout_piece: 1500,
        taxe: 806,
        prime_total: 14231,
        product_id: 3,
        age_id: 1,
        duration_id: 1,
    },
    {
        id: 134,
        prime_nette: 12421,
        cout_piece: 1500,
        taxe: 835,
        prime_total: 14756,
        product_id: 3,
        age_id: 1,
        duration_id: 2,
    },
    {
        id: 135,
        prime_nette: 15314,
        cout_piece: 1500,
        taxe: 1009,
        prime_total: 17823,
        product_id: 3,
        age_id: 1,
        duration_id: 3,
    },
    {
        id: 136,
        prime_nette: 17964,
        cout_piece: 1500,
        taxe: 1168,
        prime_total: 20632,
        product_id: 3,
        age_id: 1,
        duration_id: 4,
    },
    {
        id: 137,
        prime_nette: 24714,
        cout_piece: 1500,
        taxe: 1573,
        prime_total: 27786,
        product_id: 3,
        age_id: 1,
        duration_id: 5,
    },
    {
        id: 138,
        prime_nette: 27367,
        cout_piece: 1500,
        taxe: 1732,
        prime_total: 30599,
        product_id: 3,
        age_id: 1,
        duration_id: 6,
    },
    {
        id: 139,
        prime_nette: 29778,
        cout_piece: 1500,
        taxe: 1877,
        prime_total: 33154,
        product_id: 3,
        age_id: 1,
        duration_id: 7,
    },
    {
        id: 140,
        prime_nette: 33153,
        cout_piece: 1500,
        taxe: 2079,
        prime_total: 36732,
        product_id: 3,
        age_id: 1,
        duration_id: 8,
    },
    {
        id: 141,
        prime_nette: 40384,
        cout_piece: 1500,
        taxe: 2513,
        prime_total: 44398,
        product_id: 3,
        age_id: 1,
        duration_id: 9,
    },
    {
        id: 142,
        prime_nette: 43517,
        cout_piece: 1500,
        taxe: 2701,
        prime_total: 47718,
        product_id: 3,
        age_id: 1,
        duration_id: 10,
    },
    {
        id: 143,
        prime_nette: 80883,
        cout_piece: 1500,
        taxe: 4943,
        prime_total: 87326,
        product_id: 3,
        age_id: 1,
        duration_id: 11,
    },

    // De 19 à 65 ans
    // Produit A - Economie
    {
        id: 144,
        prime_nette: 7357,
        cout_piece: 1500,
        taxe: 531,
        prime_total: 9388,
        product_id: 1,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 145,
        prime_nette: 8321,
        cout_piece: 1500,
        taxe: 589,
        prime_total: 10411,
        product_id: 1,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 146,
        prime_nette: 9286,
        cout_piece: 1500,
        taxe: 647,
        prime_total: 11433,
        product_id: 1,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 147,
        prime_nette: 11699,
        cout_piece: 1500,
        taxe: 792,
        prime_total: 13991,
        product_id: 1,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 148,
        prime_nette: 12664,
        cout_piece: 1500,
        taxe: 850,
        prime_total: 15014,
        product_id: 1,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 149,
        prime_nette: 15071,
        cout_piece: 1500,
        taxe: 994,
        prime_total: 17565,
        product_id: 1,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 150,
        prime_nette: 18449,
        cout_piece: 1500,
        taxe: 1197,
        prime_total: 21146,
        product_id: 1,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 151,
        prime_nette: 24235,
        cout_piece: 1500,
        taxe: 1544,
        prime_total: 27279,
        product_id: 1,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 152,
        prime_nette: 28571,
        cout_piece: 1500,
        taxe: 1804,
        prime_total: 31875,
        product_id: 1,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 153,
        prime_nette: 34842,
        cout_piece: 1500,
        taxe: 2180,
        prime_total: 38522,
        product_id: 1,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 154,
        prime_nette: 64248,
        cout_piece: 1500,
        taxe: 3945,
        prime_total: 69693,
        product_id: 1,
        age_id: 2,
        duration_id: 11,
    },
    
    // Produit B - Perle
    {
        id: 155,
        prime_nette: 11214,
        cout_piece: 1500,
        taxe: 763,
        prime_total: 13477,
        product_id: 2,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 156,
        prime_nette: 12178,
        cout_piece: 1500,
        taxe: 821,
        prime_total: 14499,
        product_id: 2,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 157,
        prime_nette: 15556,
        cout_piece: 1500,
        taxe: 1023,
        prime_total: 18080,
        product_id: 2,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 158,
        prime_nette: 17000,
        cout_piece: 1500,
        taxe: 1110,
        prime_total: 19610,
        product_id: 2,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 159,
        prime_nette: 20857,
        cout_piece: 1500,
        taxe: 1341,
        prime_total: 23698,
        product_id: 2,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 160,
        prime_nette: 22785,
        cout_piece: 1500,
        taxe: 1457,
        prime_total: 25742,
        product_id: 2,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 161,
        prime_nette: 25199,
        cout_piece: 1500,
        taxe: 1602,
        prime_total: 28301,
        product_id: 2,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 162,
        prime_nette: 35806,
        cout_piece: 1500,
        taxe: 2238,
        prime_total: 39544,
        product_id: 2,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 163,
        prime_nette: 40142,
        cout_piece: 1500,
        taxe: 2499,
        prime_total: 44140,
        product_id: 2,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 164,
        prime_nette: 46892,
        cout_piece: 1500,
        taxe: 2903,
        prime_total: 51295,
        product_id: 2,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 165,
        prime_nette: 84983,
        cout_piece: 1500,
        taxe: 5189,
        prime_total: 91672,
        product_id: 2,
        age_id: 2,
        duration_id: 11,
    },

    // Produit C - Voyageur
    {
        id: 166,
        prime_nette: 20352,
        cout_piece: 1500,
        taxe: 1311,
        prime_total: 23163,
        product_id: 3,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 167,
        prime_nette: 21342,
        cout_piece: 1500,
        taxe: 1371,
        prime_total: 24213,
        product_id: 3,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 168,
        prime_nette: 27128,
        cout_piece: 1500,
        taxe: 1718,
        prime_total: 30345,
        product_id: 3,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 169,
        prime_nette: 32428,
        cout_piece: 1500,
        taxe: 2036,
        prime_total: 35963,
        product_id: 3,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 170,
        prime_nette: 45927,
        cout_piece: 1500,
        taxe: 2846,
        prime_total: 50273,
        product_id: 3,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 171,
        prime_nette: 51234,
        cout_piece: 1500,
        taxe: 3164,
        prime_total: 55898,
        product_id: 3,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 172,
        prime_nette: 56055,
        cout_piece: 1500,
        taxe: 3453,
        prime_total: 61009,
        product_id: 3,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 173,
        prime_nette: 62805,
        cout_piece: 1500,
        taxe: 3858,
        prime_total: 68163,
        product_id: 3,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 174,
        prime_nette: 77269,
        cout_piece: 1500,
        taxe: 4726,
        prime_total: 83495,
        product_id: 3,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 175,
        prime_nette: 83533,
        cout_piece: 1500,
        taxe: 5102,
        prime_total: 90135,
        product_id: 3,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 176,
        prime_nette: 158266,
        cout_piece: 1500,
        taxe: 9586,
        prime_total: 169352,
        product_id: 3,
        age_id: 2,
        duration_id: 11,
    },

    // Produit D - Famille
    {
        id: 177,
        prime_nette: 18449,
        cout_piece: 1500,
        taxe: 1197,
        prime_total: 21146,
        product_id: 4,
        age_id: 2,
        duration_id: 1,
    },
    {
        id: 178,
        prime_nette: 21821,
        cout_piece: 1500,
        taxe: 1399,
        prime_total: 24720,
        product_id: 4,
        age_id: 2,
        duration_id: 2,
    },
    {
        id: 179,
        prime_nette: 25199,
        cout_piece: 1500,
        taxe: 1602,
        prime_total: 28301,
        product_id: 4,
        age_id: 2,
        duration_id: 3,
    },
    {
        id: 180,
        prime_nette: 34356,
        cout_piece: 1500,
        taxe: 2151,
        prime_total: 38008,
        product_id: 4,
        age_id: 2,
        duration_id: 4,
    },
    {
        id: 181,
        prime_nette: 36285,
        cout_piece: 1500,
        taxe: 2267,
        prime_total: 40052,
        product_id: 4,
        age_id: 2,
        duration_id: 5,
    },
    {
        id: 182,
        prime_nette: 38699,
        cout_piece: 1500,
        taxe: 2412,
        prime_total: 42611,
        product_id: 4,
        age_id: 2,
        duration_id: 6,
    },
    {
        id: 183,
        prime_nette: 41591,
        cout_piece: 1500,
        taxe: 2585,
        prime_total: 45677,
        product_id: 4,
        age_id: 2,
        duration_id: 7,
    },
    {
        id: 184,
        prime_nette: 57984,
        cout_piece: 1500,
        taxe: 3569,
        prime_total: 63053,
        product_id: 4,
        age_id: 2,
        duration_id: 8,
    },
    {
        id: 185,
        prime_nette: 89804,
        cout_piece: 1500,
        taxe: 5478,
        prime_total: 96783,
        product_id: 4,
        age_id: 2,
        duration_id: 9,
    },
    {
        id: 186,
        prime_nette: 97997,
        cout_piece: 1500,
        taxe: 5970,
        prime_total: 105467,
        product_id: 4,
        age_id: 2,
        duration_id: 10,
    },
    {
        id: 187,
        prime_nette: 187673,
        cout_piece: 1500,
        taxe: 11350,
        prime_total: 200523,
        product_id: 4,
        age_id: 2,
        duration_id: 10,
    },

    // De 66 à 75 ans
    {
        id: 188,
        prime_nette: 9286,
        cout_piece: 1500,
        taxe: 647,
        prime_total: 11433,
        product_id: 1,
        age_id: 3,
        duration_id: 1,
    },
    {
        id: 189,
        prime_nette: 10732,
        cout_piece: 1500,
        taxe: 734,
        prime_total: 12966,
        product_id: 1,
        age_id: 3,
        duration_id: 2,
    },
    {
        id: 190,
        prime_nette: 12178,
        cout_piece: 1500,
        taxe: 821,
        prime_total: 14499,
        product_id: 1,
        age_id: 3,
        duration_id: 3,
    },
    {
        id: 191,
        prime_nette: 15799,
        cout_piece: 1500,
        taxe: 1038,
        prime_total: 18337,
        product_id: 1,
        age_id: 3,
        duration_id: 4,
    },
    {
        id: 192,
        prime_nette: 17246,
        cout_piece: 1500,
        taxe: 1125,
        prime_total: 19870,
        product_id: 1,
        age_id: 3,
        duration_id: 5,
    },
    {
        id: 193,
        prime_nette: 20857,
        cout_piece: 1500,
        taxe: 1038,
        prime_total: 18337,
        product_id: 1,
        age_id: 3,
        duration_id: 6,
    },
    {
        id: 194,
        prime_nette: 25924,
        cout_piece: 1500,
        taxe: 1645,
        prime_total: 23698,
        product_id: 1,
        age_id: 3,
        duration_id: 7,
    },
    {
        id: 195,
        prime_nette: 34602,
        cout_piece: 1500,
        taxe: 2166,
        prime_total: 38268,
        product_id: 1,
        age_id: 3,
        duration_id: 8,
    },
    {
        id: 196,
        prime_nette: 41106,
        cout_piece: 1500,
        taxe: 2556,
        prime_total: 45162,
        product_id: 1,
        age_id: 3,
        duration_id: 9,
    },
    {
        id: 197,
        prime_nette: 50512,
        cout_piece: 1500,
        taxe: 3121,
        prime_total: 55133,
        product_id: 1,
        age_id: 3,
        duration_id: 10,
    },
    {
        id: 198,
        prime_nette: 94622,
        cout_piece: 1500,
        taxe: 5767,
        prime_total: 101890,
        product_id: 1,
        age_id: 3,
        duration_id: 11,
    },

    // Produit B - Perle
    {
        id: 199,
        prime_nette: 15071,
        cout_piece: 1500,
        taxe: 994,
        prime_total: 17565,
        product_id: 2,
        age_id: 3,
        duration_id: 1,
    },
    {
        id: 200,
        prime_nette: 16517,
        cout_piece: 1500,
        taxe: 1081,
        prime_total: 19099,
        product_id: 2,
        age_id: 3,
        duration_id: 2,
    },
    {
        id: 201,
        prime_nette: 21585,
        cout_piece: 1500,
        taxe: 1385,
        prime_total: 24470,
        product_id: 2,
        age_id: 3,
        duration_id: 3,
    },
    {
        id: 202,
        prime_nette: 23749,
        cout_piece: 1500,
        taxe: 1515,
        prime_total: 26764,
        product_id: 2,
        age_id: 3,
        duration_id: 4,
    },
    {
        id: 203,
        prime_nette: 29535,
        cout_piece: 1500,
        taxe: 1862,
        prime_total: 32897,
        product_id: 2,
        age_id: 3,
        duration_id: 5,
    },
    {
        id: 204,
        prime_nette: 32428,
        cout_piece: 1500,
        taxe: 2036,
        prime_total: 35963,
        product_id: 2,
        age_id: 3,
        duration_id: 6,
    },
    {
        id: 205,
        prime_nette: 36049,
        cout_piece: 1500,
        taxe: 2253,
        prime_total: 39802,
        product_id: 2,
        age_id: 3,
        duration_id: 7,
    },
    {
        id: 206,
        prime_nette: 51959,
        cout_piece: 1500,
        taxe: 3208,
        prime_total: 56666,
        product_id: 2,
        age_id: 3,
        duration_id: 8,
    },
    {
        id: 207,
        prime_nette: 58463,
        cout_piece: 1500,
        taxe: 3598,
        prime_total: 63560,
        product_id: 2,
        age_id: 3,
        duration_id: 9,
    },
    {
        id: 208,
        prime_nette: 68587,
        cout_piece: 1500,
        taxe: 4205,
        prime_total: 74293,
        product_id: 2,
        age_id: 3,
        duration_id: 10,
    },
    {
        id: 209,
        prime_nette: 125724,
        cout_piece: 1500,
        taxe: 7633,
        prime_total: 134858,
        product_id: 2,
        age_id: 3,
        duration_id: 11,
    },

    // Produit C - Voyageur
    {
        id: 210,
        prime_nette: 28777,
        cout_piece: 1500,
        taxe: 1817,
        prime_total: 32094,
        product_id: 3,
        age_id: 3,
        duration_id: 1,
    },
    {
        id: 211,
        prime_nette: 30263,
        cout_piece: 1500,
        taxe: 1906,
        prime_total: 33669,
        product_id: 3,
        age_id: 3,
        duration_id: 2,
    },
    {
        id: 212,
        prime_nette: 38941,
        cout_piece: 1500,
        taxe: 2426,
        prime_total: 42868,
        product_id: 3,
        age_id: 3,
        duration_id: 3,
    },
    {
        id: 213,
        prime_nette: 46892,
        cout_piece: 1500,
        taxe: 2903,
        prime_total: 51295,
        product_id: 3,
        age_id: 3,
        duration_id: 4,
    },
    {
        id: 214,
        prime_nette: 67141,
        cout_piece: 1500,
        taxe: 4118,
        prime_total: 72759,
        product_id: 3,
        age_id: 3,
        duration_id: 5,
    },
    {
        id: 215,
        prime_nette: 75101,
        cout_piece: 1500,
        taxe: 4596,
        prime_total: 81197,
        product_id: 3,
        age_id: 3,
        duration_id: 6,
    },
    {
        id: 216,
        prime_nette: 82333,
        cout_piece: 1500,
        taxe: 5030,
        prime_total: 88863,
        product_id: 3,
        age_id: 3,
        duration_id: 7,
    },
    {
        id: 217,
        prime_nette: 92458,
        cout_piece: 1500,
        taxe: 5637,
        prime_total: 99595,
        product_id: 3,
        age_id: 3,
        duration_id: 8,
    },
    {
        id: 218,
        prime_nette: 114153,
        cout_piece: 1500,
        taxe: 6939,
        prime_total: 122593,
        product_id: 3,
        age_id: 3,
        duration_id: 9,
    },
    {
        id: 219,
        prime_nette: 123650,
        cout_piece: 1500,
        taxe: 7503,
        prime_total: 132553,
        product_id: 3,
        age_id: 3,
        duration_id: 10,
    },
    {
        id: 220,
        prime_nette: 235650,
        cout_piece: 1500,
        taxe: 14229,
        prime_total: 251379,
        product_id: 3,
        age_id: 3,
        duration_id: 11,
    },

    // De 76 à 80 ans
    // Produit A - Economie
    {
        id: 221,
        prime_nette: 11214,
        cout_piece: 1500,
        taxe: 763,
        prime_total: 13477,
        product_id: 1,
        age_id: 4,
        duration_id: 1,
    },
    {
        id: 222,
        prime_nette: 13143,
        cout_piece: 1500,
        taxe: 879,
        prime_total: 15521,
        product_id: 1,
        age_id: 4,
        duration_id: 2,
    },
    {
        id: 223,
        prime_nette: 15071,
        cout_piece: 1500,
        taxe: 994,
        prime_total: 17565,
        product_id: 1,
        age_id: 4,
        duration_id: 3,
    },
    {
        id: 224,
        prime_nette: 19899,
        cout_piece: 1500,
        taxe: 1284,
        prime_total: 22683,
        product_id: 1,
        age_id: 4,
        duration_id: 4,
    },
    {
        id: 225,
        prime_nette: 21827,
        cout_piece: 1500,
        taxe: 1400,
        prime_total: 24727,
        product_id: 1,
        age_id: 4,
        duration_id: 5,
    },
    {
        id: 226,
        prime_nette: 26642,
        cout_piece: 1500,
        taxe: 1689,
        prime_total: 29831,
        product_id: 1,
        age_id: 4,
        duration_id: 6,
    },
    {
        id: 227,
        prime_nette: 33399,
        cout_piece: 1500,
        taxe: 2094,
        prime_total: 36992,
        product_id: 1,
        age_id: 4,
        duration_id: 7,
    },
    {
        id: 228,
        prime_nette: 44970,
        cout_piece: 1500,
        taxe: 2788,
        prime_total: 49258,
        product_id: 1,
        age_id: 4,
        duration_id: 8,
    },
    {
        id: 229,
        prime_nette: 53641,
        cout_piece: 1500,
        taxe: 2788,
        prime_total: 49258,
        product_id: 1,
        age_id: 4,
        duration_id: 9,
    },
    {
        id: 230,
        prime_nette: 66183,
        cout_piece: 1500,
        taxe: 4061,
        prime_total: 71744,
        product_id: 1,
        age_id: 4,
        duration_id: 10,
    },
    {
        id: 231,
        prime_nette: 124996,
        cout_piece: 1500,
        taxe: 7590,
        prime_total: 134086,
        product_id: 1,
        age_id: 4,
        duration_id: 11,
    },
    
    // Produit B - Perle
    {
        id: 232,
        prime_nette: 18928,
        cout_piece: 1500,
        taxe: 1226,
        prime_total: 21654,
        product_id: 2,
        age_id: 4,
        duration_id: 1,
    },
    {
        id: 233,
        prime_nette: 20857,
        cout_piece: 1500,
        taxe: 1341,
        prime_total: 23698,
        product_id: 2,
        age_id: 4,
        duration_id: 2,
    },
    {
        id: 234,
        prime_nette: 27613,
        cout_piece: 1500,
        taxe: 1747,
        prime_total: 30860,
        product_id: 2,
        age_id: 4,
        duration_id: 3,
    },
    {
        id: 235,
        prime_nette: 30499,
        cout_piece: 1500,
        taxe: 1920,
        prime_total: 33919,
        product_id: 2,
        age_id: 4,
        duration_id: 4,
    },
    {
        id: 236,
        prime_nette: 38213,
        cout_piece: 1500,
        taxe: 2383,
        prime_total: 42096,
        product_id: 2,
        age_id: 4,
        duration_id: 5,
    },
    {
        id: 237,
        prime_nette: 42070,
        cout_piece: 1500,
        taxe: 2614,
        prime_total: 46184,
        product_id: 2,
        age_id: 4,
        duration_id: 6,
    },
    {
        id: 238,
        prime_nette: 46898,
        cout_piece: 1500,
        taxe: 2904,
        prime_total: 51302,
        product_id: 2,
        age_id: 4,
        duration_id: 7,
    },
    {
        id: 239,
        prime_nette: 68112,
        cout_piece: 1500,
        taxe: 4177,
        prime_total: 73788,
        product_id: 2,
        age_id: 4,
        duration_id: 8,
    },
    {
        id: 240,
        prime_nette: 76784,
        cout_piece: 1500,
        taxe: 4697,
        prime_total: 82981,
        product_id: 2,
        age_id: 4,
        duration_id: 9,
    },
    {
        id: 241,
        prime_nette: 90283,
        cout_piece: 1500,
        taxe: 5507,
        prime_total: 97290,
        product_id: 2,
        age_id: 4,
        duration_id: 10,
    },
    {
        id: 242,
        prime_nette: 166466,
        cout_piece: 1500,
        taxe: 10078,
        prime_total: 178044,
        product_id: 2,
        age_id: 4,
        duration_id: 11,
    },
    
    // Produit C - Voyageur
    {
        id: 243,
        prime_nette: 37203,
        cout_piece: 1500,
        taxe: 2322,
        prime_total: 41025,
        product_id: 3,
        age_id: 4,
        duration_id: 1,
    },
    {
        id: 244,
        prime_nette: 39184,
        cout_piece: 1500,
        taxe: 2441,
        prime_total: 43125,
        product_id: 3,
        age_id: 4,
        duration_id: 2,
    },
    {
        id: 245,
        prime_nette: 50755,
        cout_piece: 1500,
        taxe: 3135,
        prime_total: 55390,
        product_id: 3,
        age_id: 4,
        duration_id: 3,
    },
    {
        id: 246,
        prime_nette: 61355,
        cout_piece: 1500,
        taxe: 3771,
        prime_total: 66627,
        product_id: 3,
        age_id: 4,
        duration_id: 4,
    },
    {
        id: 247,
        prime_nette: 88355,
        cout_piece: 1500,
        taxe: 5391,
        prime_total: 95246,
        product_id: 3,
        age_id: 4,
        duration_id: 5,
    },
    {
        id: 248,
        prime_nette: 98968,
        cout_piece: 1500,
        taxe: 6028,
        prime_total: 106496,
        product_id: 3,
        age_id: 4,
        duration_id: 6,
    },
    {
        id: 249,
        prime_nette: 108611,
        cout_piece: 1500,
        taxe: 6607,
        prime_total: 116717,
        product_id: 3,
        age_id: 4,
        duration_id: 7,
    },
    {
        id: 250,
        prime_nette: 122110,
        cout_piece: 1500,
        taxe: 7417,
        prime_total: 131027,
        product_id: 3,
        age_id: 4,
        duration_id: 8,
    },
    {
        id: 251,
        prime_nette: 151038,
        cout_piece: 1500,
        taxe: 9152,
        prime_total: 161690,
        product_id: 3,
        age_id: 4,
        duration_id: 9,
    },
    {
        id: 252,
        prime_nette: 163567,
        cout_piece: 1500,
        taxe: 9904,
        prime_total: 174971,
        product_id: 3,
        age_id: 4,
        duration_id: 10,
    },
    {
        id: 253,
        prime_nette: 313033,
        cout_piece: 1500,
        taxe: 18872,
        prime_total: 333405,
        product_id: 3,
        age_id: 4,
        duration_id: 11,
    },

    /* Plan Etudiant */
    // Produit A - Etudiant Economique
    {
        id: 254,
        prime_nette: 103783,
        cout_piece: 1500,
        taxe: 6317,
        prime_total: 111600,
        product_id: 5,
        duration_id: 12,
    },
    {
        id: 255,
        prime_nette: 116318,
        cout_piece: 1500,
        taxe: 7069,
        prime_total: 124887,
        product_id: 5,
        duration_id: 13,
    },
    {
        id: 256,
        prime_nette: 129818,
        cout_piece: 1500,
        taxe: 7879,
        prime_total: 139197,
        product_id: 5,
        duration_id: 14,
    },

    // Produit B - Etudiant Classique
    {
        id: 257,
        prime_nette: 115839,
        cout_piece: 1500,
        taxe: 7040,
        prime_total: 124380,
        product_id: 6,
        duration_id: 12,
    },
    {
        id: 258,
        prime_nette: 130303,
        cout_piece: 1500,
        taxe: 7908,
        prime_total: 139711,
        product_id: 6,
        duration_id: 13,
    },
    {
        id: 259,
        prime_nette: 145246,
        cout_piece: 1500,
        taxe: 8805,
        prime_total: 155550,
        product_id: 6,
        duration_id: 14,
    },

    // Produit C - Etudiant Premium
    {
        id: 260,
        prime_nette: 122589,
        cout_piece: 1500,
        taxe: 7445,
        prime_total: 131534,
        product_id: 7,
        duration_id: 12,
    },
    {
        id: 261,
        prime_nette: 139946,
        cout_piece: 1500,
        taxe: 8487,
        prime_total: 149932,
        product_id: 7,
        duration_id: 13,
    },
    {
        id: 262,
        prime_nette: 157781,
        cout_piece: 1500,
        taxe: 9557,
        prime_total: 168838,
        product_id: 7,
        duration_id: 14,
    },

    /* Pèlerinage */
    // Produit A - Pèlerinage Basic
    {
        id: 263,
        prime_nette: 6878,
        cout_piece: 1500,
        taxe: 503,
        prime_total: 8881,
        product_id: 8,
        duration_id: 15,
    },
    {
        id: 264,
        prime_nette: 10735,
        cout_piece: 1500,
        taxe: 734,
        prime_total: 12969,
        product_id: 8,
        duration_id: 16,
    },
    {
        id: 265,
        prime_nette: 14592,
        cout_piece: 1500,
        taxe: 966,
        prime_total: 17058,
        product_id: 8,
        duration_id: 17,
    },

    // Produit B - Pèlerinage Plus
    {
        id: 266,
        prime_nette: 7842,
        cout_piece: 1500,
        taxe: 561,
        prime_total: 9903,
        product_id: 9,
        duration_id: 15,
    },
    {
        id: 267,
        prime_nette: 13143,
        cout_piece: 1500,
        taxe: 879,
        prime_total: 15521,
        product_id: 9,
        duration_id: 16,
    },
    {
        id: 268,
        prime_nette: 16035,
        cout_piece: 1500,
        taxe: 1052,
        prime_total: 18587,
        product_id: 9,
        duration_id: 17,
    },

    // Produit C - Pèlerinage Extra
    {
        id: 269,
        prime_nette: 8321,
        cout_piece: 1500,
        taxe: 589,
        prime_total: 10411,
        product_id: 10,
        duration_id: 15,
    },
    {
        id: 270,
        prime_nette: 14592,
        cout_piece: 1500,
        taxe: 966,
        prime_total: 17058,
        product_id: 10,
        duration_id: 16,
    },
    {
        id: 271,
        prime_nette: 18449,
        cout_piece: 1500,
        taxe: 1197,
        prime_total: 21146,
        product_id: 10,
        duration_id: 17,
    },
]

export const Products = [
    {
        id: 1,
        label: "Produit A",
        description: "Economie",
        zone_id: 3
    },
    {
        id: 2,
        label: "Produit B",
        description: "Perle",
        zone_id: 3
    },
    {
        id: 3,
        label: "Produit C",
        description: "Voyageur",
        zone_id: 3
    },
    {
        id: 4,
        label: "Produit D",
        description: "Famille (Personne détentrice de la police + Epoux(se) + 3 enfants à charge de moins de 18 ans)",
        age_id: 2,
        zone_id: 3
    },

    // Students 
    {
        id: 5,
        label: "Produit A",
        description: "Etudiant Economique",
        zone_id: 4,
    },
    {
        id: 6,
        label: "Produit B",
        description: "Etudiant Classique",
        zone_id: 4,
    },
    {
        id: 7,
        label: "Produit C",
        description: "Etudiant Premium",
        zone_id: 4,
    },

    // Pilgrimages
    {
        id: 8,
        label: "Produit A",
        description: "Pèlerinage Basic",
        zone_id: 5
    },
    {
        id: 9,
        label: "Produit B",
        description: "Pèlerinage Plus",
        zone_id: 5
    },
    {
        id: 10,
        label: "Produit C",
        description: "Pèlerinage Extra",
        zone_id: 5
    },
]
